export default "__VITE_ASSET__bdij3TO___"